import InnerComponent from '@Components/Sales/Invoice/InvoiceForm';
import orgContainer from '@Components/AppContainer';

const CreateInvoice = () => ((orgContainer(InnerComponent)));
export default CreateInvoice;
